import React from "react"
import style from "./style.module.css"

const opts = "autoplay=0&fs=1&iv_load_policy=1&showinfo=0&rel=0&cc_load_policy=0&start=0&end=0"


const Video = ({ src, originalWidth = 16, originalHeight = 9 }) => (
    <div
        style={{ paddingBottom: `${(originalHeight / originalWidth) * 100}%` }}
        className={style.videoWrapper}>
        <iframe title={src} src={`${src}?${opts}`} frameBorder="0" allowFullScreen="allowFullScreen"></iframe>
    </div>
)

export default Video


// WEBPACK FOOTER //
// ./src/components/simple/Video/index.js